import "./glitchtip";
import "./app.css";
import "./assets/styles/framex.scss";
import App from "./App.svelte";
import { UX_MODE } from "#src/env.js";

// Change favicon & title for SHPX mode
if (UX_MODE === "shpx") {
  const favicon = document.querySelector("link[rel~='icon']");
  if (favicon) {
    favicon.href = "/favicon-shpx.ico?v=2";
  }
  document.title = "SHPX.ai";
}

const app = new App({
  target: document.getElementById("app"),
});

export default app;
